import {useCallback} from 'react';
import {useLocalization} from 'localization';
import {useSnacks} from 'components/snacks';
import type {Media} from '../types';
import {useLazyGetMediaUrlQuery} from '../mediaApi';

export const useOpenMultipleMedia = (
  media: Media[] | undefined,
): {
  previewAll: () => Promise<void>;
} => {
  const {t} = useLocalization();
  const {errorSnack} = useSnacks();
  const [getMediaUrlQuery] = useLazyGetMediaUrlQuery();

  /**
   * Browsers are not happy with triggering multiple "popups" within a short
   * timespan, so we create a small delay. Users probably also has to whitelist
   * ebba as allowed to trigger popups like this.
   */
  const openWithDelay = useCallback((urls: Array<string | undefined>) => {
    for (let i = 0; i < urls.length; i++) {
      setTimeout(() => {
        if (urls[i]) {
          window.open(urls[i], '_blank', 'noopener,noreferrer');
        }
      }, i * 100);
    }
  }, []);

  const previewAll = useCallback(() => {
    const mediaUrls: Promise<string | undefined>[] = [];
    if (!media || !media.length) {
      return Promise.resolve();
    }

    media.forEach(file => {
      mediaUrls.push(getMediaUrlQuery(file).unwrap());
      //mediaUrls.push(getMediaUrl.apply(null, [file.id, getTokens, mock]));
    });

    return Promise.all(mediaUrls)
      .then(urls => openWithDelay(urls))
      .catch(() => {
        errorSnack(t('error.files.failedToOpen'));
      });
  }, [media, getMediaUrlQuery, openWithDelay, errorSnack, t]);

  return {
    previewAll,
  };
};
